document.addEventListener('DOMContentLoaded', function () {

    const TargetList = new Map(); //to store the initial height of the element

    document.querySelectorAll('.authorTeaserTextCollapse').forEach(function (author) {
        // Create Invisible Container to get the height of the element without touching the visible element
        // It has to be an invisble container because of the loading time of the page
        // Without it the text container would flicker or do other weird things
        let tempTextContainer = document.createElement('div');
        tempTextContainer.innerHTML = author.innerHTML;
        tempTextContainer.style.position = "absolute";
        tempTextContainer.style.visibility = "hidden";
        tempTextContainer.style.height = "fit-content";
        author.parentElement.appendChild(tempTextContainer);
        let elementHeight = tempTextContainer.getClientRects()[0].height
        tempTextContainer.remove() //remove the invisible container

        if (elementHeight > 75) {
            author.parentElement.querySelector('.collapseButton').style.display = 'block'
            TargetList.set(author, elementHeight);
        }
    });

    document.querySelectorAll('.collapseButton').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault()
            let targetId = "collapseText-" + e.target.getAttribute('nodeId')
            let targetElement = document.getElementById(targetId)
            let targetHeight = TargetList.get(targetElement)

            if (targetElement.classList.contains('open')) {
                targetElement.style.height = '75px'
                e.target.innerHTML = e.target.getAttribute('data-lang-open')
            } else {
                targetElement.style.height = targetHeight + 'px'
                e.target.innerHTML = e.target.getAttribute('data-lang-Close')
            }
            targetElement.classList.toggle('open')
        })
    })
}, false)
